import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import { LanguageDispatchTypes, RelationshipDispatchTypes } from "../models/DispatchTypes/MemberDetails";
import { LanguageMasterActionDispatchTypes, RelationshipActionDispatchTypes } from "../constants/MemberDetails";
import { GetLanguageMaster, GetRelationshipMaster } from "../services/MemberDetails";
import { configUrl } from "../constants/Config";

export const GetLanguageMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    LanguageDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_INVOKE,
    });
    const response = await GetLanguageMaster(configUrl);

    dispatch({
      response,
      type: LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_SUCCESS,
    });
  };
};

export const getRelationshipMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    RelationshipDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: RelationshipActionDispatchTypes.RELATIONSHIP_INVOKE,
    });
    const response = await GetRelationshipMaster(configUrl);
    dispatch({
      response,
      type: RelationshipActionDispatchTypes.RELATIONSHIP_SUCCESS,
    });
  };
};